export default "__VITE_ASSET__Buq0em5E__"